// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Fechamentos_ResultadoFinanceiroResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response Contract for /fechamentos/resultado_financeiro
 *
 * GET /fechamentos/resultado_financeiro/{id}
 *
 * Returns complete financial report for a fechamento
 */
import type { Fechamentos_ResultadoFinanceiroAcumuladoRow } from './Fechamentos_ResultadoFinanceiroAcumuladoRow'
import type { Fechamentos_ResultadoFinanceiroMetasRow } from './Fechamentos_ResultadoFinanceiroMetasRow'
import type { Fechamentos_ResultadoFinanceiroPlanoContasRow } from './Fechamentos_ResultadoFinanceiroPlanoContasRow'
import type { Fechamentos_ResultadoFinanceiroPrevisoesRow } from './Fechamentos_ResultadoFinanceiroPrevisoesRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Fechamentos_ResultadoFinanceiroResponseDados {
fechamento_id: number
periodo: string
data_inicial: string
data_final: string
status: string
metas: Fechamentos_ResultadoFinanceiroMetasRow
previsoes: Fechamentos_ResultadoFinanceiroPrevisoesRow
acumulado: Fechamentos_ResultadoFinanceiroAcumuladoRow
plano_contas: Fechamentos_ResultadoFinanceiroPlanoContasRow
lucro_mensal: number
caixa_mensal: number
margem_lucro: number
ticket_medio: number
}

export type Fechamentos_ResultadoFinanceiroResponse = ApiResponse<Fechamentos_ResultadoFinanceiroResponseDados>;

registerResponseContract('Fechamentos_ResultadoFinanceiroResponse', {
  fechamento_id: { type: 'number',  required: true },
  periodo:       { type: 'string',  required: true },
  data_inicial:  { type: 'string',  required: true },
  data_final:    { type: 'string',  required: true },
  status:        { type: 'string',  required: true },
  metas: {
    type: 'object',
    required: true,
    fields: {
      faturamento: {
        type: 'object',
        required: true,
        fields: {
          meta:       { type: 'number',  required: true },
          realizado:  { type: 'number',  required: true },
          diferenca:  { type: 'number',  required: true },
          percentual: { type: 'number',  required: true },
        },
      },
      clientes: {
        type: 'object',
        required: true,
        fields: {
          meta:       { type: 'number',  required: true },
          realizado:  { type: 'number',  required: true },
          diferenca:  { type: 'number',  required: true },
          percentual: { type: 'number',  required: true },
        },
      },
      itens: {
        type: 'object',
        required: true,
        fields: {
          meta:       { type: 'number',  required: true },
          realizado:  { type: 'number',  required: true },
          diferenca:  { type: 'number',  required: true },
          percentual: { type: 'number',  required: true },
        },
      },
    },
  },
  previsoes: {
    type: 'object',
    required: true,
    fields: {
      marketing:       { type: 'number',  required: true },
      insumos:         { type: 'number',  required: true },
      impostos:        { type: 'number',  required: true },
      taxas_cobranca:  { type: 'number',  required: true },
      folha_pagamento: { type: 'number',  required: true },
    },
  },
  acumulado: {
    type: 'object',
    required: true,
    fields: {
      numero_clientes:                { type: 'number',  required: true },
      faturamento_vendas:             { type: 'number',  required: true },
      total_recebimentos:             { type: 'number',  required: true },
      total_recebimentos_disponiveis: { type: 'number',  required: true },
      total_recebido_dinheiro:        { type: 'number',  required: true },
      total_despesas_pagas:           { type: 'number',  required: true },
    },
  },
  plano_contas: {
    type: 'object',
    required: true,
    fields: {
      total_previsto:      { type: 'number',  required: true },
      total_efetivo:       { type: 'number',  required: true },
      variacao_percentual: { type: 'number',  required: false },
    },
  },
  lucro_mensal:  { type: 'number',  required: true },
  caixa_mensal:  { type: 'number',  required: true },
  margem_lucro:  { type: 'number',  required: true },
  ticket_medio:  { type: 'number',  required: true },
})
